import React, {Component} from 'react';
import {
    Alert,
    Button,
    Checkbox,
    Col,
    Divider,
    Drawer,
    Form,
    Icon,
    Input,
    message,
    Popconfirm,
    Radio,
    Row,
    Switch
} from 'antd';
import {checkUserByEmail, deleteUser, isAdminRole, resetUserPassword, updateUser} from "../../services/UsersService";
import {PERMISSION_INVITES, SECURITY_ROLE_OWNER, SECURITY_ROLE_USER} from "../../constants/constants";
import {removeFromArray, showError} from "../../services/APIService";
import TextArea from "antd/es/input/TextArea";

const validator = require("email-validator");

const Search = Input.Search;

export class UsersBase extends Component {

    constructor(props) {
        super(props);

        const user = this.initUser(props.user);

        this.state = {
            user: user,
            isAdmin: isAdminRole(),
            groups: props.groups,
            actions: props.actions,
            currentUser: props.currentUser,
            verified: false
        };
    }

    deleteUser = (user) => {
        this.setState({isLoading: true});
        deleteUser(user.id).then(() => {
            this.props.onDelete(user);
        });
    };

    saveUser = () => {
        this.setState({isLoading: true});
        const user = this.state.user;
        user.clients[this.state.currentClient]['actions'] = [];
        Object.keys(this.state.actions).map(id => this.handleUserClientProperties('actions', id, 'ADD'));

        updateUser(user, this.props.currentClient).then(userFromDb => {
            this.props.onSave(userFromDb);
        }).catch(error => {
            if (error.status === 412) {
                error.json().then(json => {
                    showError(this.props.t(json.message));
                })
            }
            this.props.onSave(null);
        })
    };

    showDrawer = () => {
        this.setState({
            keyValue: new Date().getTime(),
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.saveUser();
                this.onClose();
            }
        });
    };

    onClose = () => {
        this.setState({
            email: '',
            verified: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    handleUserValues = (property, value) => {
        let user = this.state.user;
        user[property] = value;
        this.setState({user: user});
    };

    handleUserClientValues = (clientId, property, value) => {
        let user = this.state.user;
        if (!user.clients) {
            user.clients = {};
        }
        if (!user.clients[clientId]) {
            user.clients[clientId] = {};
        }
        user.clients[clientId][property] = value;
        this.setState({user: user});
    };

    handleUserClientProperties = (property, value, type) => {
        let user = this.state.user;
        if (type === 'ADD') {
            user.clients[this.state.currentClient][property].push(value);
        } else {
            removeFromArray(user.clients[this.state.currentClient][property], value);
        }
        this.setState({user: user});
    };

    getKey = () => {
        return (this.state.user && this.state.user.id ? this.state.user.id : "").replace(".", "_");
    };

    disableEditFields = () => {
        return this.state.isAdmin === true
            || (this.state.user && this.state.user.clients && Object.keys(this.state.user.clients).length > 1);
    };

    emailValidator = (rule, value, callback) => {
        if (value && !validator.validate(value)) {
            callback("error");
        }
        callback();
    };

    handleEmail = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const value = this.state.email;
                checkUserByEmail(value, this.state.currentClient).then(userFromDb => {
                    const user = this.initUser(userFromDb);
                    this.setState({
                        user: user,
                        verified: true

                    });
                }).catch(error => {
                    if (error.status === 404) {
                        const user = this.initUser({email: value});
                        this.setState({
                            user: user,
                            verified: true
                        });
                    }
                });
            }
        });
    };

    resetUserPassword = (user) => {
        resetUserPassword(user, this.state.currentClient).then(response => {
            message.success('Se generó una nueva contraseña para este usuario, se le ha notificado a su correo electrónico', 8);
        }).catch(error => {
            message.error('Error: no se ha podido completar esta operación', 5);
        });
    };

    clearEmail = () => {
        this.setState({
            email: undefined,
            user: undefined,
            verified: false
        });
    };

    initUser(user) {
        if (user) {
            user.pass = null;
        }
        if (!user.clients) {
            user.clients = {};
        }
        if (!user.clients[this.props.currentClient]) {
            user.clients[this.props.currentClient] = {};
            user.clients[this.props.currentClient].groups = [];
            user.clients[this.props.currentClient].actions = [];
        }
        return user;
    }

    getPropertyValue(property, defaultValue) {
        return (this.state.user
            && this.state.user.clients
            && this.state.user.clients[this.state.currentClient]
            && this.state.user.clients[this.state.currentClient][property])
            ? this.state.user.clients[this.state.currentClient][property] : defaultValue;
    }

    containsPropertyArrayValue(propertyArray, value) {
        if (this.state.user
            && this.state.user.clients
            && this.state.user.clients[this.state.currentClient]
            && this.state.user.clients[this.state.currentClient][propertyArray]) {
            return this.state.user.clients[this.state.currentClient][propertyArray].includes(value);
        }
        return false;
    }

    printGroups(key) {
        const groups = [];
        if (this.state && this.state.groups) {
            Object.values(this.state.groups).forEach(
                group => {
                    groups.push(
                        <Col className="group-selector" span={24} key={group.id + key}>
                            <Checkbox checked={this.containsPropertyArrayValue("groups", group.id)} value={group.id}
                                      onChange={e => this.handleUserClientProperties('groups', group.id, e.target.checked ? 'ADD' : 'REMOVE')}>
                                {group.name}
                            </Checkbox>
                        </Col>
                    );
                }
            );
        }
        return <div>{groups}</div>;
    }

    customButtons() {
        return "";
    }

    componentDidUpdate() {
        const user = this.initUser(this.props.user);
        const changes = {
            currentClient: this.props.currentClient,
            groups: this.props.groups,
            actions: this.props.actions,
            client: this.props.client,
            user: user
        };
        const values = this.props.currentClient ? JSON.stringify(changes) : "{}";
        if (!this.state.propValues || this.state.propValues !== values) {
            this.setState({
                propValues: values,
                groups: this.props.groups ? this.props.groups : this.state.groups,
                client: this.props.client ? this.props.client : this.state.client,
                actions: this.props.actions ? this.props.actions : this.state.actions,
                currentClient: this.props.currentClient ? this.props.currentClient : this.state.currentClient,
                user: user
            });
        }
    }

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        const key = this.getKey();

        return <span key={"user" + key}>
            <Drawer
                title='Usuario'
                placement="right"
                closable={true}
                onClose={this.onClose}
                maskClosable={false}
                width={'calc((100% - 1000)>0?790:100%)'}
                visible={this.props.showEdit}
                key={"drawer-" + key}
                style={{
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: 53,
                }}>
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    <Row gutter={16}>
                    {
                        this.props.userChecked || this.state.verified ?
                            <div>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item label="Correo electrónico">
                                            <Form.Item>
                                                <Input value={this.state.user ? this.state.user.email : ''}/>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="Nombre">
                                            {getFieldDecorator('name' + key, {
                                                initialValue: (this.state.client ? this.state.user.name : ''),
                                                rules: [{
                                                    required: true, message: 'Campo obligatorio',
                                                }],
                                            })(
                                                <Input placeholder='Nombre'
                                                       onChange={(e) => this.handleUserValues("name", e.target.value)}/>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item label="Identificación">
                                            {getFieldDecorator('identification' + key, {
                                                initialValue: (this.state.client ? this.state.user.identification : ''),
                                                rules: [{
                                                    required: true, message: 'Campo obligatorio',
                                                }],
                                            })(
                                                <Input placeholder='Identificación'
                                                       onChange={(e) => this.handleUserValues("identification", e.target.value)}/>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider>En este espacio</Divider>
                                <Row gutter={16} className="action-separator">
                                    <Col span={24}>
                                        {
                                            this.getPropertyValue('role', SECURITY_ROLE_USER) === SECURITY_ROLE_USER ?
                                                <Alert
                                                    message="Acceso de acuerdo a las políticas definidas por los administradores"
                                                    type="info" showIcon/>
                                                :
                                                <Alert
                                                    message="Acceso total y privilegios para realizar cualquier modificación"
                                                    type="success" showIcon/>
                                        }
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item label="Rol">
                                            {getFieldDecorator('role' + key, {
                                                initialValue: this.getPropertyValue('role', SECURITY_ROLE_USER)
                                            })(
                                                <Radio.Group buttonStyle="solid"
                                                             onChange={(e) => this.handleUserClientValues(this.state.currentClient, "role", e.target.value)}>
                                                    <Radio.Button
                                                        value={SECURITY_ROLE_USER}>Usuario</Radio.Button>
                                                    <Radio.Button
                                                        value={SECURITY_ROLE_OWNER}>Administrador</Radio.Button>
                                                </Radio.Group>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    {
                                        this.getPropertyValue('role', SECURITY_ROLE_USER) === SECURITY_ROLE_USER ?
                                            <Col span={12}>
                                                <Form.Item label={'Puede crear invitaciones'}>
                                                    {getFieldDecorator('enabled' + key, {})(
                                                        <Switch
                                                            checked={this.state.client && this.state.user.clients[this.state.currentClient]["permissions"] && this.state.user.clients[this.state.currentClient]["permissions"].includes(PERMISSION_INVITES)}
                                                            onChange={(value) => {
                                                                const permissions = value ? [PERMISSION_INVITES] : [];
                                                                this.handleUserClientValues(this.state.currentClient, "permissions", permissions)
                                                            }}/>
                                                    )}
                                                </Form.Item>
                                            </Col> : null
                                    }
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label={'Dirección'} required={true}>
                                            {getFieldDecorator('description' + key, {
                                                initialValue: (this.state.client ? this.state.user.clients[this.state.currentClient]["address"] : ''),
                                                rules: [{
                                                    required: true, message: 'Campo obligatorio',
                                                }],
                                            })(
                                                <TextArea placeholder={'Dirección'}
                                                          type="description" onChange={(value) => {
                                                    this.handleUserClientValues(this.state.currentClient, "address", value.target.value)
                                                }}/>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {
                                    this.state.user && this.state.user.id ?
                                        <div>
                                            <Divider>Seguridad</Divider>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Alert className="action-separator x2"
                                                           message="Solamente si el usuario ha solicitado soporte a un administrador"
                                                           type="warning" showIcon/>
                                                    <div className="center">
                                                        <Popconfirm
                                                            title="¿Generar una nueva contraseña para este usuario?"
                                                            onConfirm={() => {
                                                                this.resetUserPassword(this.state.user);
                                                            }} cancelText="Cancelar">
                                                            <a href="#2"><Icon type="lock" theme="twoTone"/> Generar una
                                                                nueva contraseña</a>
                                                        </Popconfirm>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div> : null
                                }
                            </div>
                            :
                            <div>
                                <Col span={24}>
                                    <ol style={{paddingLeft: 5}}>
                                        <li>Ingrese el correo electrónico</li>
                                        <li>Complete o actualice los datos personales</li>
                                        <li>Complete la información para este espacio</li>
                                        <li>Al completar el registro, se le notificará al usuario al correo
                                            electrónico
                                        </li>
                                    </ol>
                                    <Form.Item>
                                        {getFieldDecorator('email', {
                                            initialValue: '',
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Este campo es obligatorio'
                                                },
                                                {
                                                    validator: this.emailValidator,
                                                    message: 'Correo electrónico inválido'
                                                }
                                            ],
                                        })(
                                            <Search
                                                placeholder='Correo electrónico'
                                                enterButton
                                                onSearch={value => this.setState({email: value}, this.handleEmail)}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </div>
                    }
                    </Row>
                    <div className="form-footer-separator">
                        <Button onClick={this.onClose}>Cancelar</Button>
                        <Button className="mrg-left" type="primary" htmlType="submit"
                                disabled={!this.state.verified && this.state.user && !this.state.user.id}>Aceptar</Button>
                    </div>
                </Form>
            </Drawer>
            {this.customButtons()}
        </span>
    }
}


// WEBPACK FOOTER //
// ./src/app/views/users/UsersBase.js